<!--
  ~ Copyright (c) 2024 NEXTWELL INTL SRL. All Rights Reserved.
  ~ This software is the proprietary information of NEXTWELL INTL SRL.
  ~ Use is subject to license and non-disclosure terms
  -->

<div class='full-page p-5'>
  <div class='content'>
    <div class='title'><h1>{{ 'shell-app.termsAndConditions.title' | translate }}</h1></div>
    <div class='body mt-lg'>
      @if (termsAndConditions) {
        <div [innerHTML]="termsAndConditions?.template | safe : 'html'">
        </div>
      } @else {
        <bs-skeleton height='100vh' />
      }
    </div>

  </div>

  <div class='footer py'>
    @if (termsAndConditions) {
      <button bsButton type='button'
              (click)='accept()' data-testid="accept-btn"><span bsButtonLabel>{{ 'shell-app.termsAndConditions.accept' | translate }}</span></button>
    }
  </div>
</div>


